import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BlogView from '../views/BlogView.vue'
import PortfolioView from '../views/PortfolioView.vue'
import ResumeView from '../views/ResumeView.vue'
import ContactView from '../views/ContactView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: 'Home' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    meta: { title: 'About' },
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    meta: { title: 'Blog' },
    component: () => import('../views/BlogView.vue')
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    meta: { title: 'Portfolio' },
    component: () => import('../views/PortfolioView.vue')
  },
  {
    path: '/resume',
    name: 'resume',
    meta: { title: 'Résumé' },
    component: () => import('../views/ResumeView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { title: 'Contact' },
    component: () => import('../views/ContactView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// give each page its own browser tab title
router.afterEach((to) => {
  const site = 'Raymond Rhys Heredia | Web Developer'
  document.title = to.meta.title ? `${to.meta.title} | ${site}` : site
})

export default router
